import { setTerm } from './helpers';

export const setLayoutType = setTerm('room_type');
